/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Outsourced} from "../Outsourced";
import {gsap} from "gsap";
import {OutsourcedSymbol} from "../reels/symbols/OutsourcedSymbol";

export class OursourcedIdleNormalPresentation implements FlowStatePresentation {
    constructor() {
    }

    public start(flowStateController:FlowStateController) {
        flowStateController.finish();
    }
}